/* Auteur: Alexis Harrington
 * Description: Transforme un numéro de mois en le nom du mois en texte
 * Date: 2020-06-18 */
export function NomMois(numeroMois, majuscule) {
	let nomsMois = [
		"janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"
	];
    let nomsMoisMaj = [
		"Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
	];
    let nomMois;

    if(majuscule === true)
	    nomMois = nomsMoisMaj[numeroMois];
    else
        nomMois = nomsMois[numeroMois];
	return nomMois;
}

/* Auteur: Alexis Harrington
 * Description: Transforme un numéro de mois en le nom du mois en texte
 * Date: 2020-06-23 */
export function NomJour(numeroJour, majuscule) {
	let nomsJours = [
		"dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"
	];
    let nomsJoursMaj = [
		"Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"
	];
    let nomJour;

    if(majuscule === true)
	    nomJour = nomsJoursMaj[numeroJour];
    else
        nomJour = nomsJours[numeroJour];
	return nomJour;
}